import { type Transaction } from '@hooks-api/types/dataModel/fpOrder'

export const hasTransactionGiveaway = (transaction?: Transaction) => {
  if (!transaction) return false
  const hasOfflineGiveaways = !!transaction?.has_offline_giveaway
  const hasOnlineGiveaways = !!transaction?.child_orders
    .flatMap(childOrder => childOrder.order_items)
    .flatMap(orderItem => orderItem.is_giveaway)
    .some(isGiveaway => isGiveaway)
  return hasOfflineGiveaways || hasOnlineGiveaways
}
